module.exports = __webpack_public_path__ + "static/talks-hero-image-1532a06d08221a160c8443fa32529730.jpg";